import React from "react";
import { Phone, Send } from "lucide-react";
import { company } from "../mock";
import GHLForm from "./GHLForm";

const ContactForm = () => {
  return (
    <section className="bg-brand-cream py-20" id="contact">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-start">
        <div className="lg:pt-6">
          <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
            We're Here To Help
          </p>
          <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl leading-tight mb-5">
            Get Your Free Estimate Today
          </h2>
          <p className="text-slate-600 leading-relaxed mb-8 max-w-md">
            Fill out the form and a member of our team will contact you to build
            the right plan for your home. Free inspections, honest pricing, and
            work backed by our 100% satisfaction guarantee.
          </p>

          <a
            href={company.phoneHref}
            data-testid="contact-call-cta"
            className="inline-flex items-center gap-4 bg-white rounded-2xl p-4 shadow-sm border border-black/5 hover:shadow-md transition-shadow"
          >
            <div className="w-12 h-12 rounded-full bg-brand-orange flex items-center justify-center">
              <Phone className="w-6 h-6 text-white" />
            </div>
            <div className="text-left">
              <p className="text-sm text-slate-500">Call us directly</p>
              <p className="font-display font-bold text-brand-navy text-xl">
                {company.phone}
              </p>
            </div>
          </a>
        </div>

        <div className="bg-white rounded-3xl shadow-xl border border-black/5 overflow-hidden">
          <div className="bg-brand-navy px-6 py-5 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-brand-orange flex items-center justify-center shrink-0">
              <Send className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-display font-bold text-white text-lg leading-tight">
                Request Your Free Estimate
              </h3>
              <p className="text-white/60 text-sm">
                Takes under a minute · No obligation
              </p>
            </div>
          </div>
          <div className="p-2 sm:p-3">
            <GHLForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
